import { MagnifyingGlassIcon, XMarkIcon } from "@heroicons/react/24/outline"
import React from "react"
import { connectSearchBox } from "react-instantsearch-dom"
// import { SearchIcon, XIcon } from "@heroicons/react/outline"

export default connectSearchBox(
  ({ refine, currentRefinement, className, onFocus, placeholder }) => (
    <div
      className={
        className +
        "relative flex max-w-md flex-row items-center rounded border border-green"
      }
    // onSubmit={event => {
    //   event.preventDefault()
    // }}
    >
      <MagnifyingGlassIcon className="h-6 w-6 text-gray-600 mx-2" aria-hidden="true" />

      <input
        className="w-full px-0 leading-tight cursor-text border-none focus:outline-none focus:ring-0"
        type="text"
        placeholder={placeholder || "Search"}
        aria-label={placeholder || "Search"}
        onChange={e => refine(e.target.value)}
        value={currentRefinement}
        onFocus={onFocus}
      />
      <button aria-label="Reset query" onClick={() => refine("")}>
        <XMarkIcon className="h-6 w-6 p-1 text-gray-600 hover:text-gray-900 mx-1" />
      </button>
    </div>
  )
)
